import {Image} from "antd"
import React, {useState} from "react"
import {useHistory} from "react-router-dom"
import {getAvatarInitials, HSLtoString} from "../utilities"

function Avatars({id, src, name, className, style, isPreview, action, mediaClass, mediaStyle, noClick}) {
    const [error, setError] = useState(false)
    const history = useHistory()

    const handleClick = (ev) => {
        ev.stopPropagation()
        if (history.location.pathname.includes("/expert/")) {
            return false
        } else {
            history.push(`/expert/${id}`)
        }
    }

    const handleError = (ev) => {
        setError(true)
    }

    return (
        <div
            className={`flex items-center jc-center min-width-36 width-36 height-36 rounded-full font-size-14 font-white font-bold-500 o-hidden avatars animated cursor-pointer ${className ? className : ""}`}
            style={{background: HSLtoString(name), ...style}}
            onClick={(ev) => isPreview ? null : action ? action : handleClick(ev)}
        >
            {src && !error ? (
                isPreview ? (
                    <Image loading="lazy" src={src} alt={name ? name : ""} onError={handleError}
                           className={`height-full width-full obj-fit-cover ${mediaClass ? mediaClass : ""}`}
                           style={mediaStyle ? mediaStyle : null}/>
                ) : (
                    <img loading="lazy" src={src} alt={name ? name : ""} onError={handleError}
                         className={`height-full width-full obj-fit-cover ${mediaClass ? mediaClass : ""}`}
                         style={mediaStyle ? mediaStyle : null}/>
                )
            ) : (
                getAvatarInitials(name)
            )}
        </div>
    )
}

export default Avatars
